import { SpecsProvider } from '../api/SpecsContext'

import { Product } from './Product'

export const ProductScreen = () => (
	<SpecsProvider>
		<Product />
	</SpecsProvider>
)
